import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_SupplyInfos/load',
    method: 'post',
    data
  });
}

export function LoadSupply(data) {
  return request({
    url: '/Tx_SupplyInfos/LoadSupply',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_SupplyInfos/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_SupplyInfos/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Tx_SupplyInfos/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_SupplyInfos/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/Tx_SupplyInfos/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_SupplyInfos/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
